/**
 * @generated SignedSource<<0e5bbafd11c325d09e13860216014f3a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LinkSection_pageSection$data = {
  readonly anchorName: string;
  readonly linkSectionText: string | null | undefined;
  readonly links: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"ComplexLink_complexLink">;
  }>;
  readonly title: string;
  readonly titleImageBackgroundUrl: string;
  readonly titleImageUrl: string;
  readonly " $fragmentType": "LinkSection_pageSection";
};
export type LinkSection_pageSection$key = {
  readonly " $data"?: LinkSection_pageSection$data;
  readonly " $fragmentSpreads": FragmentRefs<"LinkSection_pageSection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LinkSection_pageSection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "titleImageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "titleImageBackgroundUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "anchorName",
      "storageKey": null
    },
    {
      "alias": "linkSectionText",
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ComplexLink",
      "kind": "LinkedField",
      "name": "links",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ComplexLink_complexLink"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "LinkSection",
  "abstractKey": null
};

(node as any).hash = "e1674d0938646b0f861b466ebdf7adf1";

export default node;
